<script lang="ts">
  import { chartLoadingTimeoutMessage } from '@gennetay/chart-core/map/tile-progress.svelte';

  let {
    requested,
    affected = '',
    onretry
  }: { requested: number; affected?: string; onretry: () => void } = $props();
</script>

<div class="chart-note" role="status">
  <span>{chartLoadingTimeoutMessage(requested, affected)}</span>
  <button class="retry" onclick={onretry}>Retry</button>
</div>

<style>
  .chart-note {
    display: flex;
    align-items: center;
    gap: var(--sp-4);
    padding: var(--sp-3) var(--sp-3) var(--sp-3) var(--sp-5);
    border: 1px solid var(--am-line);
    border-radius: var(--r-2);
    background: var(--panel);
    color: var(--ink);
    font: var(--fs-read) / var(--lh-read) var(--sans);
    box-shadow: var(--el-2);
    pointer-events: auto;
  }
  button {
    flex: none;
    min-height: var(--h-touch);
    border: 0;
    border-radius: var(--r-2);
    background: none;
    color: var(--ink);
    padding: 0 var(--sp-3);
    font: inherit;
    cursor: pointer;
  }
</style>
